import { useEffect, useRef } from 'react';
import { clsx } from 'clsx';

import { useAppDispatch, useAppSelector } from '@/state/hooks';
import {
  clearToast,
  openSheet,
  selectToastMessage,
} from '@/features/cart/cart-slice';

const TOAST_DURATION_MS = 4000;

const CartToast = () => {
  const dispatch = useAppDispatch();
  const toastMessage = useAppSelector(selectToastMessage);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if (!toastMessage) return;

    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(
      () => dispatch(clearToast()),
      TOAST_DURATION_MS,
    );

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [toastMessage, dispatch]);

  if (!toastMessage) return null;

  return (
    <div
      className={clsx(
        `fixed bottom-4 right-4 sm:right-6 z-50`,
        `bg-primary-600 border border-primary-400 rounded-lg px-4 py-3`,
        `text-sm flex items-center gap-3 shadow-lg`,
      )}
      role="status"
      aria-live="polite"
    >
      <span>{toastMessage}</span>
      <button
        type="button"
        onClick={() => dispatch(openSheet())}
        className="font-bold text-accent-400 hover:text-accent-300 whitespace-nowrap bg-transparent border-none cursor-pointer p-0"
      >
        View Cart →
      </button>
    </div>
  );
};

export default CartToast;
